export const START_TIME = new Date(2022, 4, 10);
export const GUESS_LENGTHS = {
  3: 9,
  4: 7,
  5: 6,
  6: 6,
  7: 6,
};
